/**
 * Interactive 3D Hover Tilt Effect for Scoped Glassmorphic Cards
 * 
 * Supports RTL, respects prefers-reduced-motion, and disables auto-tilt
 * on mobile/touch interfaces to guarantee superior performance.
 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  if (reducedMotion.matches || !hasFinePointer.matches) {
    console.log('[CARD-TILT] Tilt skipped: Touch device or prefers-reduced-motion active.');
    return;
  }

  const initializeTilt = () => {
    const cards = document.querySelectorAll('.card--glass');
    cards.forEach(card => {
      if (card.dataset.tiltInitialized === 'true') return;
      card.dataset.tiltInitialized = 'true';

      // Ensure parents don't clip 3D perspective
      let parent = card.parentElement;
      while (parent && parent !== document.body) {
        parent.style.transformStyle = 'preserve-3d';
        parent = parent.parentElement;
      }

      card.style.transformStyle = 'preserve-3d';
      card.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s cubic-bezier(0.16, 1, 0.3, 1)';

      const onPointerMove = (e) => {
        const rect = card.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        // Calculate rotation percentages (-0.5 to 0.5)
        const percentX = (mouseX / width) - 0.5;
        const percentY = (mouseY / height) - 0.5;

        // Max tilt range in degrees
        const maxTilt = 8;
        let rotateY = percentX * maxTilt;
        let rotateX = -percentY * maxTilt;

        // Adjust Y-axis tilt directions based on RTL setting
        const isRtl = document.documentElement.dir === 'rtl' || document.documentElement.getAttribute('dir') === 'rtl';
        if (isRtl) {
          rotateY = -rotateY;
        }

        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      };

      const onPointerLeave = () => {
        card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      };

      card.addEventListener('pointermove', onPointerMove, { passive: true });
      card.addEventListener('pointerleave', onPointerLeave, { passive: true });
    });
  };

  document.addEventListener('DOMContentLoaded', initializeTilt, { once: true });
  document.addEventListener('shopify:section:load', initializeTilt);
})();
